module.exports = __webpack_public_path__ + "img/astronauta-satelite.a55d6191.png";